import React, { useEffect, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import axios from 'axios';
import { toast } from 'react-toastify';

const EditConvenienceFee = ({ show, handleClose, currentFee, minTransaction, convenienceIncrement  }) => {
    const [feeAmount, setFeeAmount] = useState(currentFee);
    const [minAmount, setMinAmount] = useState(minTransaction)
    const [incrementAmount, setIncrementAmount] = useState('');
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        setFeeAmount(currentFee);
        setMinAmount(minTransaction);
        setIncrementAmount(convenienceIncrement);
    }, [currentFee, minTransaction, convenienceIncrement]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put(`${ServerPath}/convenience-fee/update`, {
                fee_id: 1,
                convenience_fee_amount: parseFloat(feeAmount),
                min_amount: parseFloat(minAmount),
                convenience_increment: parseFloat(incrementAmount),
                modified_by: "admin"
            });
    
            if (response.data.success === 1) {
                // First close the modal
                handleClose();
                
                // Wait a bit then show toast
                setTimeout(() => {
                    const toastDiv = document.createElement('div');
                    toastDiv.style.cssText = `
                        position: absolute;
                        top: 2px;
                        right: 20px;
                        background: white;
                        padding: 18px 20px;
                        border-radius: 4px;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                        z-index: 1050;
                        border-left: 4px solid #4CAF50;
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.87);
                        min-width: 250px;
                        min-height: 30px;
                    `;
                    toastDiv.textContent = 'Changes updated successfully.';
                    
                    const containerElement = document.querySelector('.container-fluid');
                    if (containerElement) {
                        containerElement.style.position = 'relative';
                        containerElement.appendChild(toastDiv);
                    }
                    
                    // Remove toast and reload after 2 seconds
                    setTimeout(() => {
                        window.location.reload();
                    }, 200);
                }, 100); // Small delay after modal closes before showing toast
            }
        } catch (error) {
            console.error('Error updating convenience fee:', error);
        }
    };

    return (
        <Modal 
            show={show} 
            onHide={handleClose}
            size="md"
            centered
        >
            <Modal.Header closeButton style={{ border: 'none', paddingBottom: '0' }}>
                <Modal.Title style={{ 
                    fontSize: '1rem',
                    fontWeight: '500',
                    color: '#111827'
                }}>
                    Edit convenience fee management
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ paddingTop: '0.5rem' }}>
                <Form onSubmit={handleSubmit}>
                    <div className="d-flex flex-row gap-3">
                        <Form.Group>
                            <Form.Label style={{
                                fontSize: '0.875rem',
                                color: '#4B5563',
                                marginBottom: '0.5rem'
                            }}>
                                Current fee amount <span style={{ color: '#DC2626' }}>*</span>
                            </Form.Label>
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center',
                                border: '1px solid #D1D5DB',
                                borderRadius: '0.375rem',
                                padding: '0.5rem 0.75rem',
                                backgroundColor: 'white'
                            }}>
                                <span style={{ color: '#4B5563', marginRight: '0.25rem' }}>₹</span>
                                <input
                                    type="text"
                                    value={feeAmount}
                                    onChange={(e) => setFeeAmount(e.target.value)}
                                    style={{
                                        border: 'none',
                                        background: 'transparent',
                                        width: '100%',
                                        outline: 'none',
                                        padding: '0'
                                    }}
                                />
                            </div>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label style={{
                                fontSize: '0.875rem',
                                color: '#4B5563',
                                marginBottom: '0.5rem'
                            }}>
                                Minimum transaction amount <span style={{ color: '#DC2626' }}>*</span>
                            </Form.Label>
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center',
                                border: '1px solid #D1D5DB',
                                borderRadius: '0.375rem',
                                padding: '0.5rem 0.75rem',
                                backgroundColor: 'white'
                            }}>
                                <span style={{ color: '#4B5563', marginRight: '0.25rem' }}>₹</span>
                                <input
                                    type="text"
                                    value={minAmount}
                                    onChange={(e) => setMinAmount(e.target.value)}
                                    style={{
                                        border: 'none',
                                        background: 'transparent',
                                        width: '100%',
                                        outline: 'none',
                                        padding: '0'
                                    }}
                                />
                            </div>
                        </Form.Group>
                    </div>

                    <div className="d-flex justify-content-end" style={{ marginTop: '2rem' }}>
                        <Button
                            type="submit"
                            style={{
                                backgroundColor: '#6366F1',
                                border: 'none',
                                padding: '0.5rem 2rem',
                                borderRadius: '0.375rem',
                                fontSize: '0.875rem'
                            }}
                        >
                            Update
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditConvenienceFee;